import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { DEFAULT_CURRENCY_CODE, formatCurrency } from '@/utils/money';
import { FONTS } from '@/styles';
import { StyleProp, Text, View, ViewStyle } from 'react-native';

interface CreditRequestItemSubtitleV2Props {
  currencyCode?: string | null;
  displayString: string;
  sku?: string | null;
  style?: StyleProp<ViewStyle>;
  unitCount: number;
  unitPriceInMicros?: number | null;
}

export const CreditRequestItemSubtitleV2: React.FC<
  CreditRequestItemSubtitleV2Props
> = ({ displayString, sku, style, unitPriceInMicros, currencyCode }) => {
  const [styles] = useStyles();

  return (
    <View style={[styles.base, style]}>
      <View style={styles.textContainer}>
        <Text style={[styles.displayText, styles.uppercaseText]}>{sku}</Text>
        {sku && displayString ? (
          <Text style={styles.displayText}>•</Text>
        ) : null}
        <Text style={[styles.displayText, styles.capitalizedText]}>
          {displayString}
        </Text>
      </View>
      <Text key="unit-price" style={FONTS.primarySemiBold}>
        {formatCurrency(
          unitPriceInMicros || 0,
          currencyCode || DEFAULT_CURRENCY_CODE,
        )}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    flex: 1,
    justifyContent: 'center',
  },
  capitalizedText: {
    textTransform: 'capitalize',
  },
  displayText: {
    color: theme.colors.inactiveText,
    fontFamily: theme.fonts.primary,
    fontSize: theme.fontSizes.small,
    lineHeight: 18,
  },
  textContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 4,
  },
  uppercaseText: {
    textTransform: 'uppercase',
  },
}));
